import { useMutation } from "react-query";
import http from 'infra/http';
import {OrcamentoCotacaoItemForm} from '../typings'

function useSaveOrcamentoCotacao(id?: string,cotacaoId?:string) {
  return useMutation(
    (data: OrcamentoCotacaoItemForm) => {
      if (cotacaoId) {
          return http.put(`/v1/orcamento/${id}/cotacao/${cotacaoId}`, data);
      }
      return http.post(`/v1/orcamento/${id}/cotacao`, data);
    },
    { retry: false }
  );
}

export default useSaveOrcamentoCotacao;
